import Vue from "vue";
let currentRequest = 0;

const UserService = {
  async fetchOne(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.find("user", id, {
        include: "tenants,role,customer"
      });
      return data.data[0];
    } catch (error) {
      console.log("fetchOne error: ", error);
      return { error: error };
    }
  },
  async fetchAll(searchFilterPagination) {
    try {
      const request = ++currentRequest;
      console.log(`[${request}] START USER `, searchFilterPagination.search);
      const res = await Vue.$jsonApi.findAll("users", searchFilterPagination);
      if (request !== currentRequest) {
        console.log(`[${request}] USER DISCARDED`);
        return null;
      }
      console.log(`[${request}] END USER `, searchFilterPagination.search);
      return res;
    } catch (error) {
      console.log("fetchAll error: ", error);
      return { error: error };
    }
  },
  async createOrUpdate(payload) {
    try {
      if (payload.id == "" || payload.id == null) {
        return await Vue.$jsonApi.create("user", payload);
      } else {
        return await Vue.$jsonApi.update("user", payload);
      }
    } catch (error) {
      console.log("createOrUpdate error: ", error);
      return { error: error };
    }
  },
  /*async updatePassword(userId, params) {
    await Vue.$jsonApi.update("user", {
      id: userId,
      password: params.password,
      confirm_password: params.confirm_password,
      old_password: params.old_password
    });
  },*/
  async loadProfile(userId) {
    if (userId) {
      try {
        const filter = {
          filter: { id: userId },
          include: "role"
        };
        const data = await Vue.$jsonApi.findAll("user", filter);
        return data.data[0];
      } catch (error) {
        console.log("loadProfile error: ", error);
        return null;
      }
    }
    return null;
  }
};

export { UserService };
